
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useAuthState } from '../../../../../../Helper/Context';
import { RegExOnlyText } from '../../../../../../Helper/regEx/RegExOnlyText';
import { AstricSign } from '../../../../../../Helper/AstricSign';
import { WorkNameDDL } from '../../../../../../Components/CommonDDL/WorkNameDDL';
import { DummyDDL } from '../../../../../../Components/CommonDDL/DummyDDL';
import { LocationDDL } from '../../../../../../Components/CommonDDL/LocationDDL';
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL';
import { PillerEleMasterPostDataAPI } from '../../../../../../Redux/ElectricalSlice/PillerSlice';
import { Loading } from '../../../../../../Helper/Loading';
import { EleStatusDDL } from '../../../../../../Components/CommonDDL/EleStatusDDL';


export default function AddElectricalPillarPopUp(props) {

    const { item, EditIcon, Flag, handleIsPost, rowData, open, handleOnCloseClick } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch();

    console.log('rowData', rowData)

    const [PillerNo, setPillerNo] = useState(Flag === 'Update' ? rowData.pillerNo : '')

    const [loading, setloading] = useState(false)

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    const [LocationName, setLocationName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [StatusName, setStatusName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handlePost = () => {
        const data = {
            M_ELEC_LocationID: LocationName?.ID,
            Active_M_ELEC_StatusID: StatusName?.ID,
            M_WardID: WardName?.ID,
            M_ELEC_PillerID: rowData?.m_eleC_PillerID,
            PillerNo: PillerNo,
            M_UserID: UserID,
            token: token,
            Flag: Flag,
            setLoading: setloading,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(PillerEleMasterPostDataAPI({ data }))
    }


    return (


        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h5 className="modal-title pt-1" id="staticBackdropLabel">{Flag === "Update" ? "Update" : "Add"} Piller</h5>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    {loading && <Loading />}

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row col-12 ">

                                <div className="col-12">
                                    <div className="form-group">
                                        <WardNameDataDDL
                                            WardName={WardName}
                                            setWardName={setWardName}
                                            HWard='0'
                                            WLable=''
                                            Type="Electrical"
                                            APIFlag="Master"
                                            rowData={rowData}
                                            Flag={Flag}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <LocationDDL
                                            WardName={WardName}
                                            LocationName={LocationName}
                                            setLocationName={setLocationName}
                                            APIFlag="Master"
                                            rowData={rowData}
                                            Flag={Flag}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">

                                        <EleStatusDDL
                                            StatusName={StatusName}
                                            setStatusName={setStatusName}
                                            APIFlag="Master"
                                            rowData={rowData}
                                            Flag={Flag}
                                        />

                                    </div>
                                </div>


                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Piller No.</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="PillerNo"
                                            value={PillerNo}
                                            // onChange={(e) => handleCheckText(e)}
                                            onChange={(e) => setPillerNo(e.target.value)}
                                        />
                                    </div>
                                </div>


                            </div>

                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            PillerNo == '' || WardName?.ID == 0 || LocationName?.ID == 0 || StatusName?.ID == 0
                                        }
                                    >{Flag === "Update" ? "Update" : "Add"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}